import { createQueryKeys } from '@lukemorales/query-key-factory';

import {
  fetchUnreadNotificationsCount,
  fetchNotifications,
} from '../api/notifications.api';

export const notificationsQueryKeys = createQueryKeys('notifications', {
  fetchInfiniteNotifications: () => ({
    queryFn: (context?: { pageParam?: string }) =>
      fetchNotifications({ limit: '20', page: context?.pageParam ?? '1' }),
    queryKey: ['list'],
  }),
  unreadCount: () => ({
    queryFn: () => fetchUnreadNotificationsCount(),
    queryKey: ['unread-count'],
  }),
});
